export default __webpack_public_path__ + "static/media/clockBattery.1056d52a.svg";